<template>
    <div class='footer'>
        <div class='copyright'>
            Copyright ⓒ FITTODAYCARE.Ins. All Rights Reserved
        </div>
        <!--
        <button @click='toggle' class='footer_right'>
            <div :class='{"footer_screen_full": fullScreenText == "화면확대", "footer_screen_normal": fullScreenText == "화면축소"}'
            >
            </div>
            <div class='footer_right_screen_message'>
                {{fullScreenText}}
            </div>
        </button>
        -->
    </div>
</template>

<script>
  import {MixinAllowedMenu} from '@/assets/js/mixinAllowedMenu';

  export default {
    name: 'TouchFooter',
    components: {
    },
    mixins: [MixinAllowedMenu],
    props: {
    },
    data() {
      return {
        fullScreenText: "화면확대",
      };
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        toggle () {
            this.$emit('toggle');
            this.fullScreenText = this.fullScreenText == "화면확대" ? "화면축소" : "화면확대";
        },
    }
  };
</script>

<style lang='scss' scoped>
    .footer_screen_full {
        width: 16px;
        height: 16px;
		background: url(/img/icons/screen_full.png) no-repeat;
        background-position: center !important;
    }

    .footer_screen_normal {
        width: 16px;
        height: 16px;
		background: url(/img/icons/screen_normal.png) no-repeat;
        background-position: center !important;
    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 2rem;
        height: 3.2rem;
        background-color: #F2F7FE;
    }

    .footer_right {
        display: flex;
        gap: 4px;
        background-color: #F2F7FE;
    }

    .footer_right_screen_message {
        font-family: Noto Sans CJK KR;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: -0.005em;
        text-align: center;
        color: #777777;
    }

    .copyright {
        font-family: Pretendard;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.005em;
        text-align: left;
        color: #BDBDBD;

        // 라지 (가로 해상도가 991px 보다 큰 화면에 적용)
        @media (min-width: 992px) {
            font-size: 1.2rem; 
            line-height:1.2rem;
        }
    }
</style>
